// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
export default (pageSize: number, page: number, offset = 0) => ({
  first: page === 1 ? pageSize - offset : pageSize,
  after: page === 1 ? null : ((page - 1) * pageSize - (offset + 1)).toString(),
});
